module.exports = __webpack_public_path__ + "media/ru_ru_s3_Nastya.6425c582.mp3";